import type { AuthorResponse } from "@/types/domain"
import { formatDistanceToNow } from "date-fns"
import { ko } from "date-fns/locale"

type PostHeaderProps = {
  author: AuthorResponse
  createdAt: string
  viewCount: number
}

const PostHeader: React.FC<PostHeaderProps> = ({ author, createdAt }) => {
  const timeAgo = formatDistanceToNow(new Date(createdAt), {
    addSuffix: true,
    locale: ko,
  })

  return (
    <div className="post-author-header">
      <div className="author-info">
        <img
          src={author.profileImageUrl ?? "https://via.placeholder.com/40"}
          alt={author.nickname}
          className="author-profile-img"
        />
        <div className="author-details">
          <div className="author-name-row">
            <span className="author-name">{author.nickname}</span>
            <span className="author-badge">
              레벨 또는 배지
            </span>
          </div>
          <div className="post-time">{timeAgo}</div>
        </div>
      </div>
      {/* 조회수는 디자인에 따라 선택적으로 표시 */}
      {/* <div className="text-xs text-gray-400">조회 {viewCount}</div> */}
    </div>
  )
}

export default PostHeader
